<app-selector [data]="backgroundCoreService.backgroundList$| async" displayKey="name" [formControl]="ctrl"
    (refreshEvent)="refresh()" hintStyle="margin-left: -14px; margin-top: -5px" [loading]="backgroundCoreService.loading" [hint]="hint" [label]="label">
</app-selector>